"use client";
import Image from "next/image";
import dotLineImage from "@/assets/images/ai/enterprise-search/process/dot-line.svg";
import dotLineHalfImage from "@/assets/images/ai/enterprise-search/process/dot-line-half.svg";
import CommonTitle from "../common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";
import process1Icon from "@/assets/images/ai/enterprise-search/process/1.svg";
import process2Icon from "@/assets/images/ai/enterprise-search/process/2.svg";
import process3Icon from "@/assets/images/ai/enterprise-search/process/3.svg";
import process4Icon from "@/assets/images/ai/enterprise-search/process/4.svg";
import process5Icon from "@/assets/images/ai/enterprise-search/process/5.svg";
import process6Icon from "@/assets/images/ai/enterprise-search/process/6.svg";

const EnterpriseWorkProcess = () => {
  const steps = [
    {
      id: 1,
      title: "Unified search across 12 platforms",
      description: "One search bar for everything",
      icon: process1Icon,
    },
    {
      id: 2,
      title: "AI-powered semantic understanding",
      description: "Understands intent, not just keywords",
      icon: process2Icon,
    },
    {
      id: 3,
      title: "Conversational answers with citations",
      description: "Get direct answers, not document dumps",
      icon: process3Icon,
    },
    {
      id: 4,
      title: "Real-time synchronization",
      description: "Always current, never outdated",
      icon: process4Icon,
    },
    {
      id: 5,
      title: "Contextual relevance",
      description: "Results personalized to your role and projects",
      icon: process5Icon,
    },
    {
      id: 6,
      title: "Built-in project management",
      description: "Search and work in one platform",
      icon: process6Icon,
    },
  ];

  return (
    <>
      <div className="bg-white px-4 py-12 xl:py-16">
        <div className="container mx-auto px-4">
          <div className="mb-12 text-center">
            <CommonTitle
              as="h2"
              fontWeightClass="font-bold"
              color="#202020"
              fontSizeClass="text-[24px] lg:text-[32px] mb-2"
            >
              How  <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">AI-powered Enterprise Search {" "}</span>Works
            </CommonTitle>
            <CommonSubtitle
              fontSizeWeight="max-w-[800px] mx-auto text-center"
            >
              Kroolo is the AI-driven workplace search platform that finally solves enterprise knowledge discovery. Unlike traditional search tools, Kroolo combines:
            </CommonSubtitle>
          </div>
          <div className="relative grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-4 xl:grid-cols-6 xl:gap-8">
            <div className="pointer-events-none absolute left-[8%] -top-[12%] z-10 hidden w-[15%] items-start justify-center xl:flex">
              <div className="flex h-full w-full items-center justify-center px-2">
                <Image
                  src={dotLineHalfImage}
                  alt="Process flow arrow"
                  width={120}
                  height={20}
                  className="h-auto w-full object-contain"
                />
              </div>
            </div>
            <div className="pointer-events-none absolute left-[22%] -top-[10%] z-10 hidden w-[36%] items-start justify-center xl:flex">
              <div className="flex h-full w-full items-center justify-center px-2">
                <Image
                  src={dotLineImage}
                  alt="Process flow arrow"
                  width={120}
                  height={20}
                  className="h-auto w-full object-contain"
                />
              </div>
            </div>
            <div className="pointer-events-none absolute left-[58%] -top-[10%] z-10 hidden w-[36%] items-start justify-center xl:flex">
              <div className="flex h-full w-full items-center justify-center px-2">
                <Image
                  src={dotLineImage}
                  alt="Process flow arrow"
                  width={120}
                  height={20}
                  className="h-auto w-full object-contain"
                />
              </div>
            </div>
            {steps.map((step, index) => (
              <div
                key={step.id}
                className={`flex flex-col items-center text-center ${index % 2 === 1 ? "xl:mt-24" : ""
                  }`}
              >
                <div className="z-50 mb-6 flex h-16 w-16 items-center justify-center p-4 bg-[#f4f4fd] rounded-full">
                  <Image
                    src={step.icon}
                    alt={step.title}
                    width={80}
                    height={80}
                    className="h-full w-full object-contain"
                  />
                </div>
                <CommonTitle
                  color="#202020"
                  fontWeightClass="font-semibold"
                  fontSizeClass="text-[14px] xl:text-[16px]"
                >
                  <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                    {step.title}
                  </span>
                </CommonTitle>
                <CommonSubtitle
                  fontSizeWeight="text-[12px] font-normal xl:text-[14px]"
                >
                  {step.description}
                </CommonSubtitle>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default EnterpriseWorkProcess;
